import * as S from './PageTemplate.styled';
import useNav from '../../../application/hooks/useNav';
import { useLocation } from 'react-router-dom';
import { useBridge } from '../../../application/hooks/useBridge';
import { AppBar } from 'oui';

interface IPageTemplate {
  children: React.ReactNode;
}

const PageTemplate = (props: IPageTemplate) => {
  const { pathname } = useLocation();
  const location = pathname.split('/')[2];
  const br: any = useBridge();
  const { historyBack } = useNav();

  const onHandlePrevBtn = () => {
    //todo 어떤 로직?
    if (location === undefined || location === 'working') {
      br.close();
    } else {
      historyBack();
    }
  };

  return (
    <>
      <S.PageTemplate>
        <S.Wrap>
          <AppBar
            type={'default'}
            title={'대출 비교'}
            leftIcon={{
              name: 'ArrowBackIosSharp',
              state: 'focused',
              size: 'lg',
              color: 'black',
            }}
            onClickPrevButton={onHandlePrevBtn}
          />
          {props.children}
        </S.Wrap>
      </S.PageTemplate>
    </>
  );
};

export default PageTemplate;
